module.exports = __webpack_public_path__ + "static/media/Right pawn top.698032ec.svg";